module.exports = __webpack_public_path__ + "img/jsxxzyjs.be200300.png";